export default "__VITE_ASSET__03cbd387__"